import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-481f6efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registration" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "pt-4 pb-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "bold mb-0" }, "Gotowe!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "registered-confirmation-text" }, " Potwierdź rejestrację klikając w link w mailu. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "registered-confirmation-small" }, " Automatycznie przeniesiemy Cię na stronę z kosztami napraw twojego samochodu. ", -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "pt-4 pb-4"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<h1 class=\"bold mb-0\" data-v-481f6efe>Zarejestruj się,</h1><h4 class=\"mt-0\" data-v-481f6efe>aby mieć dostęp do kosztów napraw</h4><p class=\"mt-2 mb-0 why-you-need-register\" data-v-481f6efe> To wymagane ze względu na ograniczenia w dostępie do danych. </p><p class=\"mt-0 why-you-need-register\" data-v-481f6efe> Możesz dodać <span class=\"bold\" data-v-481f6efe>2 samochody</span>, dla których sprawdzisz koszty napraw. </p>", 4)
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_buttons = _resolveComponent("login-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isRegistered)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              name: "email",
              class: _normalizeClass(["mt-4 form-control", { 'is-invalid': _ctx.emailError }]),
              placeholder: "Email"
            }, null, 2), [
              [_vModelText, _ctx.email]
            ]),
            (_ctx.emailError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.emailError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRegistration && _ctx.handleRegistration(...args))),
              class: "btn btn-primary mt-2 mb-4 register-button",
              disabled: _ctx.isRegistrationPending
            }, [
              (_ctx.isRegistrationPending)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Rejestruję..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "ZAREJESTRUJ"))
            ], 8, _hoisted_14)
          ])),
      _createVNode(_component_login_buttons, { "privacy-first": "" }),
      _hoisted_17
    ])
  ]))
}